import React, { useContext, useEffect, useState } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    createColumnHelper,
} from "@tanstack/react-table";
import { FilterContext } from "../../context/Filter";
import { fetchamcduedetailModalBody } from "./apiInsights";

const Amcduenextmonthtb = () => {
    const { superArn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // ✅ Fetch data from API
    const getamcdue = async () => {
        try {
            setLoading(true);
            // console.log("📤 Calling API with payload:", payload);

            const res = await fetchamcduedetailModalBody(payload);
            // console.log("✅ API raw response:", res);

            if (res?.data && Array.isArray(res.data)) {
                setData(res.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("❌ Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getamcdue();
    }, []);

    // ✅ Define table columns
    const columnHelper = createColumnHelper();

    const columns = [
        columnHelper.accessor("sno", {
            header: "SR No",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("contractType", {
            header: "Service Type",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("registrationNo", {
            header: "Reg No",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("assetNo", {
            header: "Chassis No",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("amcNumber", {
            header: "AMC Number",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("amcEndDate", {
            header: "AMC Due Date",
            cell: (info) => info.getValue(),
        }),
    ];

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-3 text-gray-700">
                AMC Due Next Month
            </h2>

            {loading ? (
                <div className="text-center py-6 text-gray-600">Loading...</div>
            ) : data.length === 0 ? (
                <div className="text-center py-6 text-gray-500">
                    No data available.
                </div>
            ) : (
                <div className="overflow-x-auto border rounded-lg shadow-sm">
                    <table className="min-w-full border-collapse">
                        <thead className="bg-gray-100">
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map((header) => (
                                        <th
                                            key={header.id}
                                            className="border px-4 py-2 text-left text-sm font-medium text-gray-700"
                                        >
                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody>
                            {table.getRowModel().rows.map((row) => (
                                <tr
                                    key={row.id}
                                    className="hover:bg-gray-50 odd:bg-white even:bg-gray-50"
                                >
                                    {row.getVisibleCells().map((cell) => (
                                        <td
                                            key={cell.id}
                                            className="border px-4 py-2 text-sm text-gray-800"
                                        >
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Amcduenextmonthtb;
